import React, { forwardRef, useImperativeHandle, useState } from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";

import { palette } from "@stepapp/ui";

export type LoaderRef = {
  showLoader: () => void;
  hideLoader: () => void;
};

export const loaderRef = React.createRef<LoaderRef>();

const Loader = forwardRef<LoaderRef>((_, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      showLoader: () => setIsVisible(true),
      hideLoader: () => setIsVisible(false),
    }),
    [],
  );

  return isVisible ? (
    <View style={styles.container}>
      <ActivityIndicator color={palette.accent.main} size="large" />
    </View>
  ) : null;
});

export default React.memo(Loader);

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    alignItems: "center",
    backgroundColor: palette.primary.loader,
    justifyContent: "center",
    zIndex: 10,
  },
});
